import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getItem, setItem } from "@purple-dot/browser-sdk/src/libraries/session-storage";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import Analytics from "../../client/analytics";
import { Head } from "./head";
import PageLevelProgressBar from "./page-level-progress-bar";
var defaultDescription = "Purple Dot lets you sell sooner to shoppers who are willing to wait. Bring products to market faster, test demand or avoid deep discounts.";
function Page(param) {
    var pageName = param.pageName, title = param.title, _titleSuffix = param.titleSuffix, titleSuffix = _titleSuffix === void 0 ? "Purple Dot" : _titleSuffix, noIndex = param.noIndex, description = param.description, head = param.head, children = param.children;
    useTrackingData(pageName);
    var titleText = "".concat(title).concat(titleSuffix ? " | " : "").concat(titleSuffix);
    var descriptionText = description || defaultDescription;
    return /*#__PURE__*/ _jsxs(PageLevelProgressBar, {
        id: pageName,
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: titleText,
                description: descriptionText,
                noIndex: noIndex,
                children: head
            }),
            _instanceof(children, Function) ? children({
                title: titleText,
                description: descriptionText
            }) : children
        ]
    });
}
function useTrackingData(pageName) {
    var router = useRouter();
    // Track when the user navigates away from their first page so we can set up exit rate
    // as a metric in our analytics and ad tools
    useEffect(function() {
        function trackUserProgressed() {
            if (!getItem("userProgressed")) {
                Analytics.trackUserProgressed(pageName);
            }
            setItem("userProgressed", true, {
                broadcast: false
            });
            router.events.off("routeChangeComplete", trackUserProgressed);
        }
        router.events.on("routeChangeComplete", trackUserProgressed);
    }, [
        pageName,
        router.events
    ]);
}
export default Page;
